import request from './request'

const SEARCH_BATCH_KEY = 'search_event_batch'
const BATCH_MAX_SIZE = 20
const FLUSH_INTERVAL_MS = 5000
const STOP_WORDS = new Set([
  '的', '了', '在', '是', '我', '有', '和', '就', '不', '人', '都', '一', '一个', '上', '也', '很', '到', '说', '要', '去', '你', '会', '着', '没有', '看', '好', '自己', '这', '那', '里', '就是', '还', '也', '但', '又', '或', '与', '及', '等', '与', '于', '为', '以', '把', '被', '让', '使', '给', '对', '从', '向', '往', '按', '按', '按', '按'
])

let flushTimer = null
let isFlushing = false

function normalizeKeyword(keyword) {
  if (!keyword) return ''
  return keyword
    .trim()
    .replace(/[^\w\u4e00-\u9fa5\s]/g, '')
    .replace(/\s+/g, ' ')
}

function filterStopWords(keyword) {
  const words = keyword.split(' ').filter(w => w.length > 1 && !STOP_WORDS.has(w))
  return words.join(' ')
}

function getIpHash() {
  let hash = localStorage.getItem('visitor_ip_hash')
  if (!hash) {
    hash = 'ip_' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36)
    localStorage.setItem('visitor_ip_hash', hash)
  }
  return hash
}

function getAuthUser() {
  try {
    return JSON.parse(localStorage.getItem('user') || localStorage.getItem('auth_user') || 'null')
  } catch (_e) {
    return null
  }
}

function getUserId() {
  const user = getAuthUser()
  return (user && (user.id || user.user_id)) || null
}

function getUserRole() {
  const user = getAuthUser()
  return (user && user.role) || 'visitor'
}

function pushToBatch(event) {
  try {
    const batch = JSON.parse(localStorage.getItem(SEARCH_BATCH_KEY) || '[]')
    batch.push(event)
    if (batch.length > BATCH_MAX_SIZE) {
      batch.shift()
    }
    localStorage.setItem(SEARCH_BATCH_KEY, JSON.stringify(batch))
  } catch (e) {
    console.warn('搜索埋点批量存储失败', e)
  }
}

async function flushBatch() {
  if (isFlushing) return
  try {
    const batch = JSON.parse(localStorage.getItem(SEARCH_BATCH_KEY) || '[]')
    if (batch.length === 0) return
    isFlushing = true
    await request.post('/api/publish/search/log', { events: batch })
    localStorage.removeItem(SEARCH_BATCH_KEY)
  } catch (e) {
    console.warn('搜索埋点上报失败', e)
  } finally {
    isFlushing = false
  }
}

function scheduleFlush() {
  if (flushTimer) clearTimeout(flushTimer)
  flushTimer = setTimeout(() => {
    flushBatch()
    scheduleFlush()
  }, FLUSH_INTERVAL_MS)
}

export function logSearchEvent({
  keyword,
  biz_type,
  result_count = 0,
  clicked_doc_id = null,
  extra = {}
}) {
  const normalized = filterStopWords(normalizeKeyword(keyword))
  if (!normalized) return

  const event = {
    keyword: normalized,
    biz_type,
    user_id: getUserId(),
    ip_hash: getIpHash(),
    user_role: getUserRole(),
    result_count,
    clicked_doc_id,
    created_at: new Date().toISOString(),
    ...extra
  }

  pushToBatch(event)
  if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
    flushBatch()
  }
}

export function initSearchTracker() {
  scheduleFlush()
  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', flushBatch)
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') flushBatch()
    })
  }
}

export function forceFlushSearchEvents() {
  return flushBatch()
}